export default __webpack_public_path__ + "static/media/icon_man.1f606516.svg";